<template>
  <div class="flex flex-col px-3 py-8 w-full h-full">
    <div class="py-3 flex flex-col text-sm">
      <span class="text-white">{{ kapal.nama_kapal }}</span>
      <span class="text-gray-300">Transmitter NO : {{ plotting.transmitter  }}</span>
      <div class="flex flex-row gap-1 px-1 py-1 mr-3 mt-3 border border-gray-400 rounded-md">
        <button
          v-if="plotting.index != 0"
          @click="toStopPlot()"
          type="button"
          class="flex justify-center items-center px-2 text-sm h-10 bg-red-500 shadow-md rounded-md">
          <i class="material-icons text-2xl text-white">stop_circle</i>
        </button>
        <button
          @click="toTogglePlot()"
          type="button"
          class="flex justify-center px-2 items-center h-10 text-sm bg-green-500 shadow-md rounded-md">
          <i class="material-icons text-2xl text-white">{{ plotting.track === 'play' ? 'pause_circle_outline' : 'play_circle_outline' }}</i>
        </button>
        <p class="flex flex-grow justify-center items-center h-10 text-sm text-white">SIMULASI PERJALANAN</p>
      </div>
    </div>
    <div class="Scroll mr-3 border border-white">
      <p
        v-if="plotting.lastIndex < 0"
        class="px-5 py-5 text-sm text-white">Tidak ada history perjalanan</p>
      <div
        v-for="(plot, plotIndex) in plotting.features"
        :key="plotIndex"
        :id="`PLOT$${plotIndex}`"
        @click="selectPlot(plotIndex)"
        class="flex flex-row justify-center items-center px-3 py-1 cursor-pointer hover:bg-gray-400">
        <i class="material-icons text-sm text-white">{{ plotting.index == plotIndex ? 'radio_button_checked' : 'radio_button_unchecked' }}</i>
        <div class="flex flex-col flex-grow px-3 py-1">
          <span class="text-xs text-white">{{ plot.ping_time }}</span>
          <span class="text-xs text-gray-300">{{ latString(plot.latitude) }}</span>
          <span class="text-xs text-gray-300">{{ lonString(plot.longitude) }}</span>
        </div>
        <div class="flex flex-grow justify-center items-center w-1/4 h-max bg-gray-500">
          <span class="text-white font-bold">{{ plot.speed / 10 }}</span>
          <small class="ml-1 text-white">knot</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import libs from '../libs'

export default {
  name: 'SidebarPlottingKapal',
  computed: {
    ...mapGetters([
      'kapal',
      'plotting'
    ])
  },
  methods: {
    ...mapActions([
      'toZoom',
      'toStopPlot',
      'toTogglePlot'
    ]),
    ...mapMutations(['setPlottingTo']),
    latString: (lat) => libs.dmsToString(libs.decToDMS(lat), 'LU', 'LS'),
    lonString: (lon) => libs.dmsToString(libs.decToDMS(lon), 'BT', 'BB'),
    selectPlot: function (index) {
      this.setPlottingTo(index)
      this.toZoom({
        view: [
          this.plotting.indexed.latitude,
          this.plotting.indexed.longitude
        ]
      })
    }
  },
  updated: function () {
    if (this.plotting.indexed.mode === 'play') {
      document.getElementById(`PLOT$${this.plotting.index}`).scrollIntoView()
    }
  }
}
</script>
